import ReactDOM from 'react-dom/client';
import ChildrenPosts from './ChildrenPosts';

window.initChildrenPosts = (childrenResourceLink) => {
  const root = ReactDOM.createRoot(document.getElementById('children-posts'));
  root.render(<ChildrenPosts childrenResourceLink={childrenResourceLink} />);
}
